import { render, staticRenderFns } from "./FinancialStatements.vue?vue&type=template&id=5f50d828&scoped=true"
import script from "./FinancialStatements.vue?vue&type=script&lang=js"
export * from "./FinancialStatements.vue?vue&type=script&lang=js"
import style0 from "./FinancialStatements.vue?vue&type=style&index=0&id=5f50d828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f50d828",
  null
  
)

export default component.exports